<template>
  <footer class="c-site-footer">
    <div class="o-wrapper">
      <div class="c-site-footer__primary u-st1 u-ff-alt">
        <div class="o-layout o-layout--stretch o-layout--large o-layout--lined">
          <div class="o-layout__item u-1/3@tablet u-mb u-mb0@tablet">
            <img src="@/assets/logo-footer.svg" height="60" alt="Chatham Island Taiko Trust">
          </div>
          <div class="o-layout__item u-1/3@tablet u-mb+ u-mb0@tablet">
            <div class="u-ph-@tablet">
              <div v-if="!mcSubmitted">
                <p>Keep up to date with the Taiko Trust by signing up to our newsletter.</p>
                <form class="c-site-footer-form u-mb" @submit.prevent="postMc">
                  <input class="c-site-footer-form__input" type="email" name="EMAIL" placeholder="Enter email address" required v-model="form.email">
                  <button class="c-site-footer-form__btn" type="submit" name="subscribe">Subscribe</button>
                </form>
              </div>
              <p v-if="mcHasMsg">{{ mcMsg }}</p>
              <a href="https://www.facebook.com/chathamtaikotrust/" target="_blank">
                <img class="u-mr--" src="@/assets/facebook.svg" width="35" height="35" alt="Facebook">
              </a>
              <a href="https://www.instagram.com/chatham_taiko_trust/" target="_blank">
                <img src="@/assets/instagram.svg" width="35" height="35" alt="Instagram">
              </a>
            </div>
          </div>
          <div class="o-layout__item u-1/3@tablet">
            <div class="u-ph-@tablet">
              <p>The Chatham Island Taiko Trust is proudly supported by NZ Red and Deepwater Group.</p>
              <a class="u-inline-block u-mr- u-mb-" href="https://www.nzred.fish/" target="_blank">
                <img src="@/assets/nz-red.svg" height="48" alt="NZ Red">
              </a>
              <a class="u-inline-block u-mb-" href="https://deepwatergroup.org/" target="_blank">
                <img src="@/assets/deepwater.png" height="48" alt="Deepwater Group">
              </a>
            </div>
          </div>
        </div>
      </div>
      <ul class="c-site-footer-links u-st2">
        <li class="c-site-footer-links__item">&copy; Chatham Island Taiko Trust 2019</li>
        <li class="c-site-footer-links__item">Email: <a class="c-site-footer-links__link" href="mailto:info@taiko.org.nz">info@taiko.org.nz</a></li>
        <li class="c-site-footer-links__item"><a class="c-site-footer-links__link" href="/privacy-policy">Privacy Policy / Terms of Use</a></li>
      </ul>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SiteFooter',
  data () {
    return {
      mcSubmitted: false,
      mcHasMsg: false,
      mcMsg: 'Your request has been sent!',
      form: {
        email: ''
      }
    }
  },
  methods: {
    postMc () {
      const vm = this
      axios.post('//taiko.us18.list-manage.com/subscribe/post-json?u=e36297c050676c3a7178a17c7&amp;id=5715e58c82&c=?', qs.stringify({
        EMAIL: vm.form.email
      }))
        .then(function (response) {
          console.log(response)
          vm.mcSubmitted = true
          vm.mcHasMsg = true
        })
        .catch(function (response) {
          console.log(response)
          vm.mcSubmitted = true
          vm.mcHasMsg = true
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SiteFooter.vue